/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import useFormatById from "src/hooks/utils/useFormatById";

export const routesSubroutes = {
    '/service-center': ['/portal', '/service-center'],
    '/account': ['/portal', '/account'],
    '/policy': ['/portal', '/policy'],
    '/providers': ['/portal', '/providers'],
    '/travel': ['/portal', '/travel'],
    '/questionary': ['/portal', '/questionary'],
    '/med-history': ['/portal', '/med-history'],
    '/compensations': ['/portal', '/compensations'],
    '/personal-doctor': ['/portal', '/personal-doctor'],
    '/appeals': ['/portal', '/appeals'],
    '/profile-doctor': ['/portal', '/profile-doctor'],
}

const Breadcrumb = () => {
    const f = useFormatById();

    const routes = {
        '/portal': f('breadCrumb.portal'),
        '/service-center': f('breadCrumb.service-center'),
        '/account': f('breadCrumb.account'),
        '/policy': f('breadCrumb.policy'),
        '/providers': f('breadCrumb.providers'),
        '/travel': f('breadCrumb.travel'),
        '/questionary': f('breadCrumb.questionary'),
        '/med-history': f('breadCrumb.med-history'),
        '/compensations': f('breadCrumb.compensations'),
        '/personal-doctor': f('breadCrumb.personal-doctor'),
        '/appeals': f('breadCrumb.appeals'),
        '/profile-doctor': f('breadCrumb.profile-doctor'),
    }

    const location = useLocation();
    const lang = useSelector(state => state.common.lang);

    const transformRouteWithId = (path) => {
        const pathSegments = path.split('/').filter(Boolean);

        const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        for (let i = 0; i < pathSegments.length; i++) {
            const segment = pathSegments[i];

            if (!isNaN(segment) || guidPattern.test(segment))
                pathSegments[i] = ':id';

            if (segment === lang)
                pathSegments[i] = '';
        }

        return `/${pathSegments.join('/')}`;
    };

    let transformedRoute = transformRouteWithId(location.pathname);

    if (transformedRoute[transformedRoute.length - 1] === '/')
        transformedRoute = transformedRoute.slice(0, -1);

    return (
        <div id="breadcrumb">
            {routesSubroutes.hasOwnProperty(transformedRoute) &&
                <div className="container mt-4">
                    {routesSubroutes?.[transformedRoute]?.map((link, index) => (
                        <span key={index}>
                            {index !== 0 && " > "}
                            {transformedRoute === link ? (
                                <a style={{ color: "#163165" }}>{routes[link]}</a>
                            ) : (
                                <Link to={link + '/' + lang} style={{ color: 'rgba(69, 64, 64, 0.70)' }}>
                                    {routes[link]}
                                </Link>
                            )}
                        </span>
                    ))}
                </div>
            }
        </div>
    );
};

export default Breadcrumb;
